import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import ModernTable, {
  ModernPageContainer,
  ModernPageHeader,
} from '../dashboard/components/ModernTable';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import { userLimits } from '../dashboard/uitls/userLimits';
import { CloudDownload, Add, Save } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ExportToCsv } from 'export-to-csv';
import { useHistory } from 'react-router';
import { Modal, Button, Form, Tabs, Tab } from '../../components/BootstrapToMUI';
import {
  Typography,
  Box,
  Chip,
  alpha,
  Stack,
  Paper,
  Button as MuiButton,
  Grid,
  Card as MuiCard,
  CardContent,
} from '@mui/material';
import KitchenIcon from '@mui/icons-material/Kitchen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const saveFridgeURL = `/machines/updateFridge`;
const getAllProdURL = `/products/`; // Endpoint to get all products
const getMachineURL = `/machines/edit/`;

export default function AddFridgeToMachine(props) {
  const theme = useTheme();
  const history = useHistory();
  const { filterd, setFiltered } = useContext(UserContext);

  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );
  const user = JSON.parse(localStorage.getItem('user'));
  const additionPriceOn = user?.features?.additionPrice;
  const theme1 = user?.theme;
  let lasturl = window.location.href.split('/').pop();
  const machineID = lasturl !== 'all' ? lasturl : null;

  const [loading, setLoading] = useState(false);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');
  const [machine, setMachine] = useState(null);
  const tableRef = React.useRef();

  // Initialize fridges state with empty arrays first
  const [fridges, setFridges] = useState([
    {
      name: 'Fridge 1',
      type: 'fridge',
      products: [],
    },
    {
      name: 'Fridge/Shelf 2',
      type: 'fridge',
      products: [],
    },
  ]);

  const [activeTab, setActiveTab] = useState('0');
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const downloadProductCsv = async (products) => {
    let newArray = [];
    products.forEach((element) => {
      const newObj = {};
      newObj.name = element.id.name;
      newObj.upc = element.id.upc;
      newObj.price = element.id.price;
      newObj.current_stock = element.id.current_stock || 0;
      newArray.push(newObj);
    });

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Machine_Products',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'Machine_Products',
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(newArray);
  };

  // Check if filterd is empty and redirect if necessary (only when no machineID)
  useEffect(() => {
    if (!machineID && (!filterd || filterd.length === 0)) {
      console.log('No machines selected, redirecting to viewMyMachines');
      history.push('/dashboard/viewMyMachines');
      return;
    }
  }, [filterd, machineID, history]);

  // Fetch machine data if machineID exists
  useEffect(() => {
    if (machineID) {
      const getMachine = async () => {
        await request({
          method: 'get',
          url: getMachineURL + machineID,
        }).then((res) => {
          setMachine(res.data);
          setTitle(res.data.name || '');
        });
      };
      getMachine();
    } else {
      // Set title from filterd
      let string = '';
      if (filterd && filterd.length > 0) {
        filterd.forEach((e) => {
          string += e.name + ', ';
        });
        string = string.substring(0, string.length - 2);
      }
      setTitle(string);
    }
  }, [machineID, filterd]);

  // Initialize fridges with data from machine or filterd and availableProducts
  useEffect(() => {
    // Get machine data from either machine state or filterd context
    let machineData = null;
    if (machineID && machine) {
      machineData = machine;
    } else if (!machineID && filterd && filterd.length > 0) {
      machineData = filterd[0];
    }

    // Always show fridges structure, even if no data yet
    if (machineData) {
      // Function to map product IDs to full product details
      const mapFridgeProductsToFullDetails = (fridgeProductIds) => {
        if (!fridgeProductIds || !Array.isArray(fridgeProductIds)) return [];
        if (availableProducts.length === 0) return [];

        return fridgeProductIds
          .map((fridgeProduct) => {
            // fridgeProduct could be just an ID string, or an object with ID and other properties
            const productId =
              typeof fridgeProduct === 'string'
                ? fridgeProduct
                : fridgeProduct._id || fridgeProduct.id || fridgeProduct;

            // Find the full product details from availableProducts
            const fullProduct = availableProducts.find(
              (product) => product.id._id === productId || product.id.id === productId
            );

            if (fullProduct) {
              return {
                id: {
                  ...fullProduct.id,
                  name:
                    fullProduct.id.name || (fullProduct.id.name?.en ? fullProduct.id.name.en : ''),
                  nPrice: fridgeProduct.nPrice || null,
                  current_stock: fridgeProduct.current_stock,
                },
                nPrice: fridgeProduct.nPrice || null, // Preserve any existing modified price
              };
            } else {
              // If product not found in availableProducts, create a placeholder
              console.warn(`Product with ID ${productId} not found in available products`);
              return {
                id: {
                  _id: productId,
                  name: 'Product not found',
                  price: 0,
                  upc: '',
                  productPictures: [],
                },
                nPrice: null,
              };
            }
          })
          .filter(Boolean); // Remove any null/undefined entries
      };

      setFridges([
        {
          name: 'Fridge 1',
          type: 'fridge',
          products: mapFridgeProductsToFullDetails(machineData.product_fridge_1),
        },
        {
          name: 'Fridge/Shelf 2',
          type: 'fridge',
          products: mapFridgeProductsToFullDetails(machineData.product_fridge_2),
        },
      ]);
    }
  }, [machineID, machine, filterd, availableProducts]); // Run when machine, filterd OR availableProducts changes

  useEffect(() => {
    // Get all available products
    const getAllProducts = async () => {
      try {
        const response = await request({
          method: 'get',
          url: getAllProdURL + id + '/plano',
        });
        if (response && response.data) {
          const newData = response.data.map((e) => ({
            id: {
              ...e,
              name: e.name.en,
            },
          }));
          setAvailableProducts(newData);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(true); // Always show UI after products fetch (success or failure)
      }
    };

    if (id) {
      getAllProducts();
    } else {
      setLoading(true); // Show UI immediately if no id
    }

    return () => {
      setAvailableProducts([]);
    };
  }, [reflesh, id]);

  const updateProd = async (id, price) => {
    let newArray = Object.values(id);
    newArray = newArray.map((e) => e.newData);

    // Update products in the current fridge too
    const updatedFridges = [...fridges];
    const activeIndex = parseInt(activeTab);
    if (updatedFridges[activeIndex] && updatedFridges[activeIndex].products) {
      newArray.forEach((changes) => {
        updatedFridges[activeIndex].products.forEach((element) => {
          if (element.id._id === changes.id._id) {
            element.id.nPrice = changes.nPrice;
            element.nPrice = changes.nPrice;
          }
        });
      });
      setFridges(updatedFridges);
    }
  };

  // Handler for saving the current fridge products
  const handleSaveFridge = () => {
    const activeIndex = parseInt(activeTab);
    Swal.fire({
      title: 'Save Changes',
      text: 'Are you sure you want to save the changes to this fridge?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!',
    }).then((result) => {
      if (result.isConfirmed) {
        let products = fridges[activeIndex].products.map((pd) => pd.id);
        if (products?.length > 0) {
          products = products.map((item) => ({
            ...item,
            id: item._id,
          }));
        }

        console.log('ActiveFridge', products);
        console.log('machineID', machineID);
        request({
          method: 'post',
          url: saveFridgeURL,
          data: {
            machineID: machineID,
            products: products,
            activeTab: activeIndex,
          },
        })
          .then((response) => {
            if (response.data) {
            }
          })
          .catch((err) => console.log(err))
          .finally(() => {});

        // For now, we'll just show a success message
        Swal.fire('Saved!', 'Your fridge configuration has been saved.', 'success');
      }
    });
  };

  // Handler for clearing all products from the current fridge
  const handleClearFridge = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, clear it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedFridges = [...fridges];
        // Clear products but keep the fridge
        updatedFridges[index].products = [];
        setFridges(updatedFridges);

        Swal.fire('Cleared!', 'All products have been removed from this fridge.', 'success');
      }
    });
  };

  // Handler for adding products to the current fridge
  const handleAddProducts = () => {
    if (selectedProducts.length === 0) {
      Swal.fire('Error', 'Please select at least one product', 'error');
      return;
    }

    const updatedFridges = [...fridges];
    const activeIndex = parseInt(activeTab);
    const currentFridge = updatedFridges[activeIndex];

    // Add selected products to current fridge
    selectedProducts.forEach((product) => {
      // Check if product already exists in the fridge
      const existingIndex = currentFridge.products.findIndex((p) => p.id._id === product.id._id);
      if (existingIndex === -1) {
        currentFridge.products.push(product);
      }
    });

    setFridges(updatedFridges);
    setSelectedProducts([]);
    setShowAddProductModal(false);
  };

  // Handler for selecting products in modal
  const handleProductSelection = (product) => {
    const selectedIndex = selectedProducts.findIndex((p) => p.id._id === product.id._id);

    if (selectedIndex > -1) {
      // Remove from selection
      const updatedSelection = [...selectedProducts];
      updatedSelection.splice(selectedIndex, 1);
      setSelectedProducts(updatedSelection);
    } else {
      // Add to selection
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  // Reset price for current fridge
  const handleResetPrice = () => {
    const activeIndex = parseInt(activeTab);
    Swal.fire({
      title: 'Are you sure to reset all prices?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reset it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const updatedFridges = [...fridges];
        const currentFridge = updatedFridges[activeIndex];

        // Reset prices for all products in current fridge
        currentFridge.products.forEach((product) => {
          product.nPrice = null;
        });

        setFridges(updatedFridges);

        Swal.fire('Price reset!', 'All products have been reset to default price.', 'success');
      }
    });
  };

  // Handler for removing a product from the current fridge
  const handleRemoveProduct = (productId) => {
    const updatedFridges = [...fridges];
    const activeIndex = parseInt(activeTab);
    const currentFridge = updatedFridges[activeIndex];

    const productIndex = currentFridge.products.findIndex((p) => p.id._id === productId);
    if (productIndex > -1) {
      currentFridge.products.splice(productIndex, 1);
      setFridges(updatedFridges);
    }
  };

  const columns = [
    {
      title: 'Picture',
      field: 'id.productPicture',
      editable: 'never',
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.id.productPictures[0]}/${id}`}
          style={{
            maxWidth: 200,
            maxHeight: 75,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
          }}
          alt={rowData.id.name}
        />
      ),
    },
    {
      title: 'Product Name',
      editable: 'never',
      field: 'id.name',
      cellStyle: {
        textAlign: 'left',
      },
      headerStyle: {
        textAlign: 'left',
      },
      render: (rowData) => (
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {rowData.id.name}
        </Typography>
      ),
    },
    {
      title: 'UPC/SKU',
      editable: 'never',
      field: 'id.upc',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          {rowData.id.upc}
        </Typography>
      ),
    },
    {
      title: 'Current Stock',
      field: 'id.current_stock',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.id.current_stock || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Actions',
      field: 'actions',
      editable: 'never',
      render: (rowData) => (
        <Button variant="danger" size="sm" onClick={() => handleRemoveProduct(rowData.id._id)}>
          <DeleteIcon fontSize="small" />
        </Button>
      ),
    },
  ];

  return (
    <ModernPageContainer>
      <ModernPageHeader
        title="Update Fridge"
        subtitle={`For Machine: ${title}`}
        icon={KitchenIcon}
        buttons={[
          {
            text: 'Go Back',
            icon: ArrowBackIcon,
            onClick: () => history.goBack(),
            variant: 'outlined',
          },
        ]}
      />

      {!loading ? (
        <LoadingIcon />
      ) : (
        <div style={{ maxWidth: '100%', margin: '0 auto' }}>
          <Box
            sx={{
              '& .MuiTab-root': {
                fontSize: '1rem',
                padding: '16px 24px',
                minHeight: '64px',
              },
              '& .MuiTabs-indicator': {
                display: 'none', // 隐藏下划线
              },
            }}
          >
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              id="fridge-tabs"
              className="mb-3 ml-3"
            >
              {fridges.map((fridge, index) => (
                <Tab
                  key={index}
                  eventKey={String(index)}
                  title={
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        {fridge.name}
                      </Typography>
                      <Box
                        component="span"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleClearFridge(index);
                        }}
                        sx={{
                          display: 'inline-flex',
                          cursor: 'pointer',
                          p: 1,
                          borderRadius: 1.5,
                          '&:hover': {
                            backgroundColor: alpha(theme.palette.error.main, 0.15),
                            color: theme.palette.error.main,
                            transform: 'scale(1.1)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        <DeleteIcon sx={{ fontSize: 20 }} />
                      </Box>
                    </Stack>
                  }
                >
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      background: `linear-gradient(135deg, ${alpha(
                        theme.palette.background.paper,
                        0.9
                      )} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
                      border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    }}
                  >
                    <Stack spacing={3}>
                      {/* Header with Title and Actions */}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        justifyContent="space-between"
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                        spacing={2}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                          }}
                        >
                          {fridge.name}
                        </Typography>

                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={1.5}
                          sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                          <MuiButton
                            variant="contained"
                            color="success"
                            startIcon={<Add />}
                            onClick={() => setShowAddProductModal(true)}
                            sx={{
                              borderRadius: 2,
                              textTransform: 'none',
                              fontWeight: 600,
                              px: 3,
                              boxShadow: `0 4px 12px ${alpha(theme.palette.success.main, 0.4)}`,
                              '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: `0 6px 20px ${alpha(theme.palette.success.main, 0.5)}`,
                              },
                              transition: 'all 0.3s ease',
                            }}
                          >
                            Add Products
                          </MuiButton>

                          <MuiButton
                            variant="contained"
                            color="primary"
                            startIcon={<Save />}
                            onClick={handleSaveFridge}
                            sx={{
                              borderRadius: 2,
                              textTransform: 'none',
                              fontWeight: 600,
                              px: 3,
                              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                              boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                              '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                              },
                              transition: 'all 0.3s ease',
                            }}
                          >
                            Save Changes
                          </MuiButton>

                          <MuiButton
                            variant="outlined"
                            color="info"
                            startIcon={<CloudDownload />}
                            onClick={() =>
                              downloadProductCsv(fridges[parseInt(activeTab)].products)
                            }
                            sx={{
                              borderRadius: 2,
                              textTransform: 'none',
                              fontWeight: 600,
                              px: 3,
                              borderWidth: '1.5px',
                              '&:hover': {
                                borderWidth: '1.5px',
                                backgroundColor: alpha(theme.palette.info.main, 0.08),
                              },
                              transition: 'all 0.3s ease',
                            }}
                          >
                            Export CSV
                          </MuiButton>
                        </Stack>
                      </Stack>

                      <ModernTable
                        tableRef={tableRef}
                        columns={columns}
                        data={fridge.products}
                        title=""
                        options={{
                          pageSizeOptions: [10, 20, 50],
                          pageSize: 10,
                          actionsColumnIndex: -1,
                          headerStyle: {
                            textAlign: 'left',
                          },
                          cellStyle: {
                            textAlign: 'left',
                          },
                          rowStyle: (rowData) => ({
                            backgroundColor: rowData.hide ? '#ffcccc' : '',
                          }),
                        }}
                      />
                    </Stack>
                  </Paper>
                </Tab>
              ))}
            </Tabs>
          </Box>
        </div>
      )}

      {/* Add Products Modal */}
      <Modal
        show={showAddProductModal}
        onHide={() => {
          setShowAddProductModal(false);
          setSelectedProducts([]);
        }}
        backdrop="static"
        keyboard={false}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Products to {fridges[parseInt(activeTab)]?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', padding: '32px' }}>
          <Box sx={{ mb: 4 }}>
            <Form.Control
              type="text"
              placeholder="Search products by name or SKU..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <Grid container spacing={3}>
            {availableProducts
              .filter((product) => {
                if (!searchTerm) return true;
                const search = searchTerm.toLowerCase();
                return (
                  product.id.name.toLowerCase().includes(search) ||
                  product.id.upc.toLowerCase().includes(search)
                );
              })
              .map((product, index) => {
                const isSelected = selectedProducts.some((p) => p.id._id === product.id._id);
                return (
                  <Grid item xs={12} sm={6} key={index}>
                    <MuiCard
                      onClick={() => handleProductSelection(product)}
                      sx={{
                        height: '100%',
                        cursor: 'pointer',
                        border: `2px solid ${
                          isSelected ? theme.palette.primary.main : 'transparent'
                        }`,
                        borderRadius: 3,
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        backgroundColor: isSelected
                          ? alpha(theme.palette.primary.main, 0.05)
                          : 'transparent',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.2)}`,
                          border: `2px solid ${theme.palette.primary.main}`,
                        },
                      }}
                    >
                      {/* Selection Indicator */}
                      {isSelected && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            zIndex: 1,
                          }}
                        >
                          <CheckCircleIcon
                            sx={{
                              fontSize: 32,
                              color: theme.palette.primary.main,
                              filter: `drop-shadow(0 2px 4px ${alpha(
                                theme.palette.primary.main,
                                0.3
                              )})`,
                            }}
                          />
                        </Box>
                      )}

                      <CardContent sx={{ p: 3 }}>
                        <Stack direction="row" spacing={3} alignItems="flex-start">
                          {/* Product Image */}
                          {product?.id?.productPictures && product?.id?.productPictures[0] && (
                            <Box
                              sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 120,
                                borderRadius: 2,
                                overflow: 'hidden',
                                backgroundColor: alpha(theme.palette.grey[100], 0.5),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                              }}
                            >
                              <img
                                src={`${process.env.REACT_APP_SERVER_API}/pictures/${product.id.productPictures[0]}/${id}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                }}
                                alt={product.id.name}
                              />
                            </Box>
                          )}

                          {/* Product Info */}
                          <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                fontSize: '1rem',
                                color: theme.palette.text.primary,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {product.id.name}
                            </Typography>

                            <Stack spacing={0.5}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: theme.palette.text.secondary,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    fontSize: '0.7rem',
                                  }}
                                >
                                  SKU:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontFamily: 'monospace',
                                    color: theme.palette.text.primary,
                                  }}
                                >
                                  {product.id.upc}
                                </Typography>
                              </Box>

                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: theme.palette.text.secondary,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    fontSize: '0.7rem',
                                  }}
                                >
                                  Price:
                                </Typography>
                                <Chip
                                  label={`$${product.id.price}`}
                                  size="small"
                                  sx={{
                                    fontWeight: 700,
                                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                                    color: theme.palette.success.dark,
                                    border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                                  }}
                                />
                              </Box>
                            </Stack>
                          </Stack>
                        </Stack>
                      </CardContent>
                    </MuiCard>
                  </Grid>
                );
              })}
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
            }}
          >
            <Chip
              label={`Selected: ${selectedProducts.length} product${
                selectedProducts.length !== 1 ? 's' : ''
              }`}
              color="primary"
              sx={{
                fontWeight: 700,
                fontSize: '0.875rem',
                height: '36px',
                px: 1,
              }}
            />
            <Stack direction="row" spacing={2}>
              <MuiButton
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setShowAddProductModal(false);
                  setSelectedProducts([]);
                  setSearchTerm('');
                }}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.5,
                  borderWidth: '1.5px',
                  '&:hover': {
                    borderWidth: '1.5px',
                  },
                }}
              >
                Cancel
              </MuiButton>
              <MuiButton
                variant="contained"
                color="primary"
                onClick={handleAddProducts}
                disabled={selectedProducts.length === 0}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.5,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                  },
                  '&:disabled': {
                    background: theme.palette.action.disabledBackground,
                    boxShadow: 'none',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Add Selected Products
              </MuiButton>
            </Stack>
          </Box>
        </Modal.Footer>
      </Modal>
    </ModernPageContainer>
  );
}
